import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingExclusions } from './types/Listing';

export default (makeCall: MakeCall) => (
  listingId: number,
  { rangeFrom, rangeTo, dates, adjustDates = true }: ListingExclusions,
) =>
  makeCall<ListingExclusions>(
    'PUT',
    `${APIV2_URL}/listing/${listingId}/exclusions`,
    {
      data: { dates, rangeFrom, rangeTo },
      query: { adjustDates },
    },
  );
